module.exports = __webpack_public_path__ + "static/media/SVdashlogoBIGdark.90b64030.png";